import TableLoader from "@/Layouts/components/Skeletons/TableLoader";
import { Box, Grid, Skeleton } from "@mui/material";

export const SupportCenterSkeleton = () => {
	return (
		<Box className="w-full rounded-[10px]">
			<Grid container>
				<Grid item xs={12}>
					<Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
						<Grid item>
							<Skeleton className="rounded-md" variant="rectangular" width={330} height={30} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Box className="h-10" />
			<Grid container direction="row" justifyContent="space-between">
				{[1, 2, 3].map((key) => (
					<Grid key={key} item>
						<Skeleton className="rounded-md" variant="rectangular" width={310} height={122} />
					</Grid>
				))}
			</Grid>
			<Box className="h-10" />
			<Skeleton className="rounded-md" variant="rectangular" width={220} height={30} />
			<Box className="h-[30px]" />
			<Skeleton className="rounded-md" variant="rectangular" width="100%" height={23} />
			<TableLoader className="-mt-[10px]" content rows={3} />
		</Box>
	);
};
